import {
    Invoice,
    InvoiceApiGetInvoicePDFRequest,
    InvoiceApiGetInvoiceRequest,
    InvoiceApiGetInvoicesRequest,
    InvoicePaymentProcessorEnum,
} from '@videoblocks/subscription-service-client';
import { LoggerFactory } from '@videoblocks/typescript-logger';

import { invoiceApi, subscriptionServiceConfig } from './subscriptionServiceConfig';

const logger = LoggerFactory.create('Subscription Service Client - Invoices Api');

const getInvoicesForUser = async (userId: number): Promise<Invoice[]> => {
    const request: InvoiceApiGetInvoicesRequest = {
        userId,
    };
    try {
        const result = await invoiceApi.getInvoices(request);
        return result.data;
    } catch (error) {
        logger.error({ userId, error }, `Error fetching Invoices for user %d`, userId);
        return [];
    }
};

const getInvoicesForOrg = async (orgId: number): Promise<Invoice[]> => {
    const request: InvoiceApiGetInvoicesRequest = {
        organizationId: orgId,
    };
    try {
        const result = await invoiceApi.getInvoices(request);
        return result.data;
    } catch (error) {
        logger.error({ orgId, error }, `Error fetching Invoices for organization %d`, orgId);
        return [];
    }
};

const getInvoice = async (invoiceId: string, paymentProcessor?: string | null): Promise<Invoice | null> => {
    try {
        const params: InvoiceApiGetInvoiceRequest = {
            id: invoiceId,
            ...(paymentProcessor && { paymentProcessor: paymentProcessor as InvoicePaymentProcessorEnum }),
        };

        const response = await invoiceApi.getInvoice(params);

        return response.data;
    } catch (error) {
        logger.error({ invoiceId, error }, `Error fetching invoice ID %s`, invoiceId);
        return null;
    }
};

const getInvoicePDF = async (invoiceId: string, paymentProcessor?: string | null): Promise<Buffer | null> => {
    try {
        const params: InvoiceApiGetInvoicePDFRequest = {
            id: invoiceId,
            ...(paymentProcessor && { paymentProcessor: paymentProcessor as InvoicePaymentProcessorEnum }),
        };

        const response = await invoiceApi.getInvoicePDF(params, { responseType: 'arraybuffer' });
        return Buffer.from(response.data as unknown as ArrayBuffer);
    } catch (error) {
        logger.error({ invoiceId, error }, `Error fetching PDF for invoice ID %s`, invoiceId);
        return null;
    }
};

export const InvoiceApi = {
    getInvoicesForUser,
    getInvoicesForOrg,
    getInvoice,
    getInvoicePDF,
};
